import qs from "qs";
import request from "@/utils/request";

export function getUsers(params) {
  return request({
    url: `/api/admin/users/`,
    method: `get`,
    params,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  });
}
export function getUserById(userId) {
  return request({
    url: `/api/admin/users/${userId}/`,
    method: `get`,
  });
}
/**
 * @example {
  "username": "admin",
  "password": "123qweASD",
  "name": "Иванов Петр Алексеевич",
  "phone": "+7 900 123-45-67",
  "email": "ivan@sidorov.me",
  "region": 0,
  "roles": [
    "user"
  ],
  "is_active": true
}
 */
export async function createUser(data) {
  return request({
    url: `/api/admin/users/`,
    method: `post`,
    data,
  });
}
export function deleteUser(userId) {
  return request({
    url: `/api/admin/users/${userId}/`,
    method: "delete",
  });
}
export function updateUser(userId, data) {
  data.email = data.email ? data.email : null;

  return request({
    url: `/api/admin/users/${userId}/`,
    method: `patch`,
    data,
  });
}
/**
 * @example {
  "password": "123qweASD"
}
 */
export function setUserPassword(userId, data) {
  return request({
    url: `/api/admin/users/${userId}/password/`,
    method: `post`,
    data,
  });
}

/**
 * Регионы пользователя
 * @param {number} userId
 */
export function getUserRegions(userId) {
  return request({
    url: `/api/admin/users/${userId}/regions/`,
    method: "get",
  });
}

/**
 * Добавить пользователя в регионы
 * @param {number} userId
 * @param {{regions: number[]}} data
 */
export function appendUserToRegions(userId, data) {
  return request({
    url: `/api/admin/users/${userId}/regions/append/`,
    method: "post",
    data: {
      regions: data.regions.map((r) => r.id),
    },
  });
}

/**
 * Удалить пользователя из регионов
 * @param {number} userId
 * @param {{regions: number[]}} data
 */
export function removeUserToRegions(userId, data) {
  return request({
    url: `/api/admin/users/${userId}/regions/remove/`,
    method: "post",
    data: {
      regions: data.regions.map((r) => r.id),
    },
  });
}

export function getUsersVrio(params) {
  return request({
    url: `/api/admin/users/vrio/`,
    method: `get`,
    params,
  });
}

export function postUsersVrio(data) {
  return request({
    url: `/api/admin/users/vrio/`,
    method: `post`,
    data,
  });
}

export function deleteUsersVrio(userId) {
  return request({
    url: `/api/admin/users/vrio/${userId}/`,
    method: `delete`,
  });
}

export function updateUsersVrio(userId, data) {
  return request({
    url: `/api/admin/users/vrio/${userId}/`,
    method: `patch`,
    data,
  });
}

export function unblockUser(userId) {
  return request({
    url: `/api/admin/users/${userId}/unblock/`,
    method: "post",
  });
}
